import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { FamilyGroupBySegmentModelDTO, GetIdTresorByFamilyFilter, LocalCampaignSegmentationFilter, RenaultPuntoapuntoCrmEntity, RenaultPuntoapuntoCrmResultTable, RenaultPuntoapuntoLocalCampaignSegmentationDTO } from '../models/renault-puntoapunto-local-campaign-segmentation-dto';

@Injectable({
  providedIn: 'root'
})

export class PuntoapuntoLocalCampaignSegmentationService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultPuntoapuntoLocalCampaignSegmentation/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultPuntoapuntoLocalCampaignSegmentationDTO> {
    return this.http.get<RenaultPuntoapuntoLocalCampaignSegmentationDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public GetEntityDataBarByUserDistributor(idCampaign = null): Observable<RenaultPuntoapuntoCrmEntity> {
    if (idCampaign != null)
      return this.http.get<RenaultPuntoapuntoCrmEntity>(this.pathAPI + this.controller + 'GetEntityDataBarByUserDistributor?idCampaign=' + idCampaign);
    else
      return this.http.get<RenaultPuntoapuntoCrmEntity>(this.pathAPI + this.controller + 'GetEntityDataBarByUserDistributor');
  }

  public GetEntityDataBarByFilter(filter: LocalCampaignSegmentationFilter, idCampaign = null): Observable<RenaultPuntoapuntoCrmEntity> {
    if (idCampaign != null)
      return this.http.post<RenaultPuntoapuntoCrmEntity>(this.pathAPI + this.controller + 'GetEntityDataBarByFilter?idCampaign=' + idCampaign, filter);
    else
      return this.http.post<RenaultPuntoapuntoCrmEntity>(this.pathAPI + this.controller + 'GetEntityDataBarByFilter/', filter);
  }

  public GetEntityDataBarByIdSegmentation(idSegmentation: string, idCampaign = null): Observable<RenaultPuntoapuntoCrmEntity> {
    if (idCampaign != null)
      return this.http.get<RenaultPuntoapuntoCrmEntity>(this.pathAPI + this.controller + 'GetEntityDataBarByIdSegmentation/' + idSegmentation + '?idCampaign=' + idCampaign);
    else
      return this.http.get<RenaultPuntoapuntoCrmEntity>(this.pathAPI + this.controller + 'GetEntityDataBarByIdSegmentation/' + idSegmentation);
  }

  public GetSegmentationsSelect(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetSegmentationsSelect');
  }

  public getFamilyGroupBySegment(): Observable<FamilyGroupBySegmentModelDTO[]> {
    return this.http.get<FamilyGroupBySegmentModelDTO[]>(this.pathAPI + this.controller + 'GetFamilyGroupBySegment');
  }

  public GetIdTresorByFamily(filter: GetIdTresorByFamilyFilter): Observable<{ [key: number]: number[][] }> {

    return this.http.post<{ [key: number]: number[][] }>(this.pathAPI + this.controller + 'GetIdTresorByFamily/', filter);

  }

  public GetFidelityPercent(idRol): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetFidelityPercent/' + idRol);
  }

  public GetUserCP(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetUserCP/');
  }

}
